import script from "./work-detail-body.vue?vue&type=script&setup=true&lang=js"
export * from "./work-detail-body.vue?vue&type=script&setup=true&lang=js"

import "./work-detail-body.vue?vue&type=style&index=0&id=3ddfd8f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddfd8f6"]])

export default __exports__